import { Route, Routes } from "react-router-dom";
import "./App.css";
import Navbar from "./componets/Navbar";

import Investmenttwo from "./screens/Investmenttwo";
import Home from "./screens/Home";
import LoanAmountSlider from "./screens/LoanCalculator";
import InputFunction from "./screens/Investmentone";
import UserContent from "./screens/Investmenttwo";

function App() {
  return (
    <div>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/loancal" element={<LoanAmountSlider />} />
        <Route path="/investone" element={<InputFunction />} />
        <Route path="/investtwo" element={<UserContent />} />
      </Routes>
    </div>
  );
}

export default App;
